ThemeController.$inject = ['$scope', '$cookies'];

function ThemeController($scope, $cookies) {
  // Generic function to get cobrand cookie
  $scope.getBrand = function () {
    return $cookies.get('brand');
  };
}

export default ThemeController;
